export function ConteudoRegulamento() {
  return (
    <div className="prose prose-invert max-w-none space-y-8 text-white/80">
      {/* Seção 1 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">1. Objetivo</h2>
        <p>
          O presente regulamento estabelece as regras de participação do Bolão Copa do Mundo 2026, destinado exclusivamente aos jogos da fase de grupos da Copa do Mundo FIFA 2026.
        </p>
        <p>
          Ao realizar o cadastro e aceitar este regulamento, o participante declara estar ciente e concordar integralmente com todas as regras aqui descritas.
        </p>
      </section>

      {/* Seção 2 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">2. Abrangência do Bolão</h2>
        <p>
          O bolão contempla exclusivamente os jogos da fase de grupos da Copa do Mundo FIFA 2026.
        </p>
        <p className="font-bold text-white">Não serão considerados para pontuação:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Oitavas de final</li>
          <li>Quartas de final</li>
          <li>Semifinais</li>
          <li>Disputa de terceiro lugar</li>
          <li>Final</li>
          <li>Qualquer partida de Mata-Mata</li>
        </ul>
        <p>A classificação final será definida ao término da fase de grupos.</p>
      </section>

      {/* Seção 3 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">3. Participação</h2>
        <p>
          Poderá participar do bolão qualquer pessoa devidamente cadastrada e liberada pela administração do sistema.
        </p>
        <p className="font-bold text-white">Para participar, o usuário deverá:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Possuir cadastro ativo</li>
          <li>Estar com a inscrição validada pela administração</li>
          <li>Realizar o pagamento da participação</li>
          <li>Enviar o comprovante de pagamento para validação</li>
          <li>Ter o pagamento confirmado pela administração do sistema</li>
          <li>Aceitar este regulamento</li>
          <li>Realizar seus palpites dentro dos prazos estabelecidos</li>
        </ul>
        <p>
          A liberação definitiva para participação no bolão estará condicionada a validação do pagamento pela administração.
        </p>
        <p>
          Usuários com pagamento pendente poderão ter restrições de acesso conforme definido pela administração.
        </p>
        <p>
          Usuários bloqueados não poderão acessar o sistema nem realizar palpites.
        </p>
      </section>

      {/* Seção 4 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">4. Validação do Pagamento</h2>
        <p>
          A participação no bolão somente será considerada efetiva após:
        </p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Realização do pagamento da inscrição</li>
          <li>Envio do comprovante de pagamento</li>
          <li>Validação do pagamento pela administração</li>
        </ul>
        <p className="font-bold text-white">O sistema registrará:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Valor pago</li>
          <li>Data do pagamento</li>
          <li>Comprovante enviado</li>
          <li>Status da validação</li>
        </ul>
        <p>
          A administração poderá solicitar novo comprovante caso o documento enviado esteja ilegível, incompleto ou apresente divergências.
        </p>
      </section>

      {/* Seção 5 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">5. Prazo para Realização dos Palpites</h2>
        <p>
          Os palpites poderão ser realizados ou alterados até 2 (duas) horas antes do horário oficial de início de cada partida.
        </p>
        <p className="font-bold text-white">Exemplo:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Horário do jogo: 20h00</li>
          <li>Prazo limite para palpite: 17h59min59s</li>
        </ul>
        <p>
          A partir das 18h00min00s o sistema bloqueará automaticamente qualquer inclusão ou alteração referente a esta partida.
        </p>
        <p>
          O horário oficial utilizado pelo sistema será: <span className="font-bold">América/São Paulo (UTC -3)</span>
        </p>
      </section>

      {/* Seção 6 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">6. Bloqueio dos Palpites</h2>
        <p>Após o encerramento do prazo:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>O palpite não poderá ser alterado</li>
          <li>O palpite não poderá ser excluído</li>
          <li>Nenhum administrador poderá modificar palpites bloqueados</li>
          <li>Jogos encerrados não poderão ser reabertos para apostas</li>
        </ul>
        <p>Todos os bloqueios são realizados automaticamente pelo sistema.</p>
      </section>

      {/* Seção 7 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">7. Sistema de Pontuação</h2>
        
        <div className="bg-white/5 rounded-lg p-6 mb-6">
          <h3 className="text-xl font-bold text-amarelobrasil mb-3">20 PONTOS</h3>
          <p className="mb-3">O participante receberá 20 pontos quando:</p>
          <ul className="list-disc list-inside space-y-2 ml-4 mb-4">
            <li>Acertar o vencedor e o placar exato</li>
            <li>Acertar empate com placar exato</li>
          </ul>
          <p className="font-bold text-white">Exemplo:</p>
          <p className="text-sm">Palpite: Brasil 2 x 1 França</p>
          <p className="text-sm">Resultado: Brasil 2 x 1 França</p>
          <p className="text-sm">Pontuação: 20 pontos</p>
        </div>

        <div className="bg-white/5 rounded-lg p-6 mb-6">
          <h3 className="text-xl font-bold text-amarelobrasil mb-3">15 PONTOS</h3>
          <p className="mb-3">O participante receberá 15 pontos quando:</p>
          <ul className="list-disc list-inside space-y-2 ml-4 mb-4">
            <li>Acertar empate sem acertar o placar exato</li>
            <li>Acertar o vencedor e a diferença de gols</li>
          </ul>
          <p className="font-bold text-white">Exemplo:</p>
          <p className="text-sm">Palpite: Brasil 2 x 1 França</p>
          <p className="text-sm">Resultado: Brasil 1 x 0 França</p>
          <p className="text-sm">Neste caso o participante acertou:</p>
          <ul className="list-disc list-inside space-y-1 ml-8 text-sm">
            <li>O vencedor</li>
            <li>A diferença de gols</li>
          </ul>
          <p className="text-sm mt-2">Pontuação: 15 pontos</p>
        </div>

        <div className="bg-white/5 rounded-lg p-6 mb-6">
          <h3 className="text-xl font-bold text-amarelobrasil mb-3">10 PONTOS</h3>
          <p className="mb-3">O participante receberá 10 pontos quando acertar apenas o vencedor da partida.</p>
          <p className="font-bold text-white">Exemplo:</p>
          <p className="text-sm">Palpite: Brasil 4 x 0 Marrocos</p>
          <p className="text-sm">Resultado: Brasil 1 x 0 Marrocos</p>
          <p className="text-sm">Pontuação: 10 pontos</p>
        </div>

        <div className="bg-white/5 rounded-lg p-6">
          <h3 className="text-xl font-bold text-amarelobrasil mb-3">0 PONTOS</h3>
          <p className="mb-3">Não haverá pontuação quando:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>O vencedor estiver incorreto</li>
            <li>O empate estiver incorreto</li>
            <li>O resultado geral da partida estiver incorreto</li>
          </ul>
        </div>
      </section>

      {/* Seção 8 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">8. Classificação e Ranking</h2>
        <p>
          O ranking será atualizado automaticamente pelo sistema sempre que um resultado oficial for lançado.
        </p>
        <p>
          A classificação será baseada na soma total dos pontos obtidos ao longo da fase de grupos.
        </p>
      </section>

      {/* Seção 9 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">9. Critérios de Desempate</h2>
        <p>Em caso de empate na classificação geral, serão utilizados os seguintes critérios, nesta ordem:</p>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>Maior número de placares exatos</li>
          <li>Maior número de placares exatos em jogos do Brasil</li>
          <li>Maior número de acertos de resultado em jogos do Brasil</li>
          <li>Maior número de palpites realizados</li>
        </ol>
        <p>
          Persistindo o empate após todos os critérios acima, a premiação correspondente será dividida igualmente entre os participantes empatados.
        </p>
      </section>

      {/* Seção 10 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">10. Premiação</h2>
        <p>
          Ao final da fase de grupos, todo o valor arrecadado será distribuído entre os cinco primeiros colocados da classificação geral.
        </p>
        <p className="font-bold text-white">Distribuição:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>1º Lugar: 40%</li>
          <li>2º Lugar: 25%</li>
          <li>3º Lugar: 20%</li>
          <li>4º Lugar: 10%</li>
          <li>5º Lugar: 5%</li>
        </ul>
        <p>
          Os valores serão calculados automaticamente pelo sistema com base no total arrecadado.
        </p>
        <p>
          Não existem premiações por rodada. Não existem premiações intermediárias. Toda premiação será definida exclusivamente pela classificação final da fase de grupos.
        </p>
      </section>

      {/* Seção 11 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">11. Resultados Oficiais</h2>
        <p>
          Os resultados das partidas serão inseridos manualmente pela administração do sistema após o encerramento oficial dos jogos.
        </p>
        <p>
          A pontuação dos participantes será recalculada automaticamente com base nos resultados cadastrados.
        </p>
      </section>

      {/* Seção 12 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">12. Auditoria e Segurança</h2>
        <p>
          Para garantir a transparência do bolão, o sistema registra automaticamente:
        </p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Data e horário dos palpites</li>
          <li>Alterações realizadas antes do bloqueio</li>
          <li>Aceite do regulamento</li>
          <li>Acessos ao sistema</li>
          <li>Operações administrativas relevantes</li>
        </ul>
        <p>Todos os registros ficam armazenados para fins de auditoria.</p>
      </section>

      {/* Seção 13 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">13. Responsabilidade dos Participantes</h2>
        <p>É responsabilidade exclusiva do participante:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Conferir seus palpites antes do encerramento do prazo</li>
          <li>Manter seus dados cadastrais atualizados</li>
          <li>Preservar sua senha de acesso</li>
          <li>Acompanhar comunicados emitidos pela administração</li>
        </ul>
        <p>
          Não serão aceitas reclamações referentes a palpites não realizados dentro do prazo estabelecido.
        </p>
      </section>

      {/* Seção 14 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">14. Aceite do Regulamento</h2>
        <p>
          Ao marcar a opção "Li e aceito as regras do Bolão Copa do Mundo 2026", o participante declara:
        </p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Ter lido integralmente este regulamento</li>
          <li>Estar de acordo com todas as regras</li>
          <li>Reconhecer os critérios de pontuação</li>
          <li>Reconhecer os critérios de desempate</li>
          <li>Concordar com os prazos e bloqueios definidos pelo sistema</li>
        </ul>
      </section>

      {/* Seção 15 */}
      <section>
        <h2 className="text-2xl font-bold text-amarelobrasil uppercase mb-4">15. Disposições Finais</h2>
        <p>
          Os casos omissos ou situações excepcionais serão analisados pela administração do bolão.
        </p>
        <p>
          A participação no bolão implica na aceitação integral deste regulamento.
        </p>
        <p className="text-lg font-bold text-amarelobrasil mt-8">
          Desejamos boa sorte a todos os participantes.
        </p>
        <p className="text-lg font-bold text-amarelobrasil">
          Bolão Copa do Mundo 2026
        </p>
      </section>
    </div>
  );
}
